import { memo } from 'react';

import { MegaphoneIcon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { MAIN_SIDE_NAV_SMALL_ICON_SIZE } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItemButton';
import { Routes } from '~/constants/routes';
import { NEW_TAB } from '~/constants/urls';

export const MainSideNavItemNewAtAir = memo(() => {
  return (
    <MainSideNavItem
      href={Routes.changelog}
      icon={MegaphoneIcon}
      id="new-at-air"
      isSelected={false}
      label="New at Air"
      iconSize={MAIN_SIDE_NAV_SMALL_ICON_SIZE}
      rel="noreferrer"
      target={NEW_TAB}
    />
  );
});

MainSideNavItemNewAtAir.displayName = 'MainSideNavItemNewAtAir';
